<template>
    <div class="directory-inline-form">
            <div class="form-group">
                <label :class="{ 'required-style': !regionData.regionName }">{{ $t('Region Name') }}</label>
                <input type="text" class="form-control" v-model="regionData.regionName" :placeholder="$t('Region Name')"/>
                <span class="text-warning" v-if="!regionData.regionName && isClicked">{{ $t('Required') }}</span>
            </div>
            <div class="directory-inline-form__actions">
                <button ref="saveBtn" @click="CreateRegion" class="btn btn-primary directory-save-btn"><i class="fa-solid fa-floppy-disk"></i> {{ $t('Save Region') }}</button>

            </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import {showDirectoryError} from '@/helpers/directoryErrorAlert.js'
import {showDirectorySuccess} from '@/helpers/directorySuccessAlert.js'
import {showDirectoryLoading, closeDirectoryLoading} from '@/helpers/directoryLoadingAlert.js'
export default {
    name : 'RegionForm',
    data(){
        return {
            regionData : {},
            isClicked :false
        }
    },
    methods : {
        ...mapActions(['CreateRegionRun']),
        CreateRegion(){
            const self = this
            const btn = self.$refs.saveBtn
            let data = self.regionData
            self.isClicked = true
            if(!data.regionName){
                return
            }
            
            btn.disabled = true
            self.isClicked = false
            showDirectoryLoading(self, {
                title: 'Creating Region',
                description: 'Saving the region and updating the directory.'
            })

            self.CreateRegionRun(data).then((res)=>{
                btn.disabled = false
                if(res=="OK"){
                    self.regionData = {}
                    closeDirectoryLoading(self)
                    showDirectorySuccess(self, {
                        description: 'The region has been created successfully and added to the directory.'
                    })
                }else{
                    closeDirectoryLoading(self)
                    showDirectoryError(self, {
                        description: res,
                        duplicateValue: data.regionName
                    })
                }
            }).catch((error)=>{
                btn.disabled = false
                closeDirectoryLoading(self)
                showDirectoryError(self, {
                    description: error?.message || 'Unable to create region. Please try again.',
                    duplicateValue: data.regionName
                })
            })
        }
    }
}
</script>
